export default __webpack_public_path__ + "static/media/Image6.62f4f608.jpg";